import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getSmsStatistics } from '../../api/getSmsStatistics';
import { queryKeys } from '../queryKeys';
import type { GetSmsStatisticsParams } from '../../api/getSmsStatistics';

export const useGetSmsStatistics = (params: GetSmsStatisticsParams, isEnabled = true) => {
    const { data, isLoading, refetch, ...rest } = useQuery({
        queryKey: queryKeys.smsStatistics(params),
        queryFn: () => getSmsStatistics(params),
        enabled: !!(params.id && isEnabled),
        placeholderData: keepPreviousData,
        refetchInterval: isEnabled ? 60000 : false,
    });

    return {
        smsStatistics: data?.smsStatistic,
        isLoadingSmsStatistics: isLoading,
        refetchSmsStatistics: refetch,
        ...rest,
    };
};
